module.exports = __webpack_public_path__ + "static/media/tiktok.3638745f.svg";